import React, { useEffect } from "react";
import { connect } from "react-redux";

import Ribs from "./Ribs";
import {
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex,
  setMenuTopIndex
} from "../../redux/actions/menuActions";
import Menu from "../accounting/Menu";

const RibContainer = props => {
  useEffect(() => {
    props.setMenuTopIndex("accounting");
    props.setMenuLeftContent(Menu);
    props.setMenuLeftIndex("iban");
    props.setMenuLeftItemIndex("");
  }, []);
  return <Ribs {...props} />;
};

const mapStateToProps = state => {
  const { email } = state.userInfos;
  const available =
    [
      "tsirizo.rabenoro@upsell.fr",
      "comptabilite.es@upsell.fr",
      "assistant.comptabilite@upsell.fr"
    ].indexOf(email) > -1;
  return {
    available,
    token: state.auth.token
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(RibContainer);



// WEBPACK FOOTER //
// src/pages/poc_rib/Ribs.container.js